import { RoutePath } from "src/data/Routes";
import { MenuNode } from "src/model/MenuNode";

const toolsPathMappings = [
  { contains: "cmdb", route: RoutePath.CMDB },
  { contains: "custom-links", route: RoutePath.CMDB },
  { contains: "topology", route: RoutePath.TOPOLOGY },
  { contains: "trends", route: RoutePath.TRENDS },
  { contains: "advisor", route: RoutePath.ADVISOR },
];

/** Tools items show a specific tool's subtree in the left menu instead of the whole class tree. */
export function resolveToolsTree(tree: MenuNode, item: MenuNode): MenuNode {
  if (tree?.children.some(mn => mn.path === item.path)) {
    tree = item;
  }
  const matchingTool = toolsPathMappings.find(tool =>
    item.path.includes(tool.contains) && tree?.children.some(mn => mn.path === tool.route));
  return matchingTool ? tree.children.find(mn => mn.path === matchingTool.route) : tree;
}
